
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immoneuf/home",
      function () {
        return require("private-next-pages/immoneuf/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immoneuf/home"])
      });
    }
  